import React, { useState, useEffect, useRef } from 'react';
import { Icon } from '@iconify/react';
import { getData, putData } from '../../webService/webservice.js';
import './NotificationIcon.css';

const NotificationIcon = () => {
    const [notifications, setNotifications] = useState([]);
    const [unreadCount, setUnreadCount] = useState(0);
    const [isOpen, setIsOpen] = useState(false);
    const dropdownRef = useRef(null);
    const role = localStorage.getItem("role");

    const fetchNotifications = async () => {
        try {
            const token = localStorage.getItem("Token");
            const response = await getData('notifications', {}, token);
            if (response && response.data) {
                setNotifications(response.data.notifications || []);
                setUnreadCount(response.data.unreadCount || 0);
            }
        } catch (error) {
            console.error("Error fetching notifications", error);
        }
    };

    const markAsRead = async () => {
        try {
            const token = localStorage.getItem("Token");
            await putData('notifications/mark-read', {}, token);
            setUnreadCount(0);
        } catch (error) {
            console.error("Error marking notifications as read", error);
        }
    };

    useEffect(() => {
        if (role === 'SuperAdmin' || role === 'SelfAdmin') {
            fetchNotifications();
        }
    }, [role]);

    useEffect(() => {
        function handleClickOutside(event) {
            if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
                setIsOpen(false);
            }
        }
        document.addEventListener('mousedown', handleClickOutside);
        return () => document.removeEventListener('mousedown', handleClickOutside);
    }, []);

    const toggleDropdown = () => {
        setIsOpen(!isOpen);
        if (!isOpen && unreadCount > 0) {
            markAsRead();
        }
    };

    if (role !== 'SuperAdmin' && role !== 'SelfAdmin') {
        return null;
    }

    return (
        <div className="notification-wrapper" ref={dropdownRef}>
            <button className="notification-btn" onClick={toggleDropdown}>
                <Icon icon="mdi:bell" style={{ fontSize: '20px' }} />
                {unreadCount > 0 && <span className="notification-badge">{unreadCount}</span>}
            </button>

            {isOpen && (
                <div className="notification-dropdown">
                    <div className="notification-header">
                        <h4>Notifications</h4>
                    </div>
                    <div className="notification-body">
                        {notifications.length === 0 ? (
                            <div className="notification-empty">No notifications</div>
                        ) : (
                            notifications.map(notif => (
                                <div key={notif._id} className="notification-item">
                                    <div className="notification-icon-box">
                                        <Icon icon="mdi:package-variant" />
                                    </div>
                                    <div className="notification-content">
                                        {notif.type === 'PendingPayment' ? (
                                            <>
                                                <div style={{ fontSize: '13px', fontWeight: 'bold', color: '#eab308' }}>New Package Payment Received</div>
                                                <p style={{ margin: '4px 0', fontSize: '12px' }}>
                                                    Store: <strong>{notif.storeName}</strong><br/>
                                                    Package: {notif.packageName}<br/>
                                                    Payment Mode: {notif.paymentMode || 'N/A'}<br/>
                                                    Amount: ₹{notif.amount?.toLocaleString('en-IN')}<br/>
                                                    Status: <span style={{ color: '#eab308', fontWeight: 600 }}>Pending Verification</span>
                                                </p>
                                            </>
                                        ) : (
                                            <p>
                                                <strong>{notif.storeName}</strong> {notif.type === 'Purchase' ? 'purchased' : 'renewed'}{' '}
                                                <strong>{notif.packageName}</strong>
                                            </p>
                                        )}
                                        <div className="notification-meta">
                                            {notif.type !== 'PendingPayment' && (
                                                <span className="notification-amount">₹{notif.amount}</span>
                                            )}
                                            <span className="notification-time">{new Date(notif.createdAt).toLocaleString()}</span>
                                        </div>
                                    </div>
                                </div>
                            ))
                        )}
                    </div>
                </div>
            )}
        </div>
    );
};

export default NotificationIcon;
